import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { IconCallButtonCircle } from '../../assets/icons';
import { IconLogoExalus, IconLogoLavva, IconLogoWisniowskiSmall } from '../../assets/logo-icons';
import { IconApple, IconFacebook, IconGoogle } from '../../assets/social-icons';
import { environment } from '../../environment';
import { useExalusMigrationWhenOnlineUnauthorized } from '../../integrations/exalus/hooks/common/use-migration-data';
import { ROUTES } from '../../routes/routes';
import { IntegrationDefaultEnum } from '../../types';
import { isProd } from '../../utils/helpers/environment';
import { isWisniowski } from '../../utils/helpers/wisniowski';
import { useLogin } from './hooks/use-login';
import './index.scss';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { t: tc } = useTranslation('common');
  const { t } = useTranslation('login');
  const { wisniowski, handleLogin, handleSocialLogin, handleRegister } = useLogin();
  const { checkOnlineMigrationWhenUnauthorized } = useExalusMigrationWhenOnlineUnauthorized();

  useEffect(() => {
    checkOnlineMigrationWhenUnauthorized();
  }, []);

  const renderIcon = () => {
    if (isWisniowski) return <IconLogoWisniowskiSmall />;
    else {
      return environment.INTEGRATION_DEFAULT === IntegrationDefaultEnum.Exalus ? (
        <IconLogoExalus className="exalus" />
      ) : (
        <IconLogoLavva />
      );
    }
  };

  return (
    <div className={classNames('login-page', { wisniowski: wisniowski })}>
      <div className="login-page__up-content">
        <div className={classNames('login-page__logo', { lower: wisniowski })}>{renderIcon()}</div>
        {!wisniowski && <p className="login-page__second-slogan">{t('sloganControlSmartfon')}</p>}
      </div>
      <div className="login-page__buttons">
        <button className="button" onClick={handleLogin}>
          {tc('login')}
        </button>
        <div className="or-separator m-t-24 m-b-24">
          <div>{tc('or')}</div>
        </div>
        <button className="button facebook m-b-16" onClick={() => handleSocialLogin('facebook')}>
          <IconFacebook /> {tc('facebookContinue')}
        </button>
        <button className="button google m-b-16" onClick={() => handleSocialLogin('google')}>
          <IconGoogle />
          {tc('googleContinue')}
        </button>
        {isProd && (
          <button className="button apple m-b-16" onClick={() => handleSocialLogin('apple')}>
            <IconApple />
            {tc('appleContinue')}
          </button>
        )}
        <button className="button button--secondary m-b-16" onClick={handleRegister}>
          {tc('register')}
        </button>
        <div className="support-link">
          <button onClick={() => navigate(ROUTES.Support())}>
            <IconCallButtonCircle />
            <p>{tc('support')}</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
